export default __webpack_public_path__ + "static/media/vodafone_play_logo_512.49db7781.png";